import { useRef, useState, useEffect } from "react";
import "./Accordion.scss";
import { Button } from "@mui/material";

function Accordion(props) {
	const [active, setActive] = useState(false);
	const [height, setHeight] = useState("0px");
	const content = useRef(null);

	useEffect(() => {
		console.log(props);
	}, [props]);

	function toggleAccordion() {
		setActive((prev) => !prev);
		setHeight(active ? "0px" : `${content.current.scrollHeight}px`);
	}

	return (
		<div className="accordion__section">
			<div
				className={`accordion ${active ? "active" : ""}`}
				onClick={toggleAccordion}
			>
				<p className="accordion__title">{props.name}</p>
				<p className="accordion__title">{props.title}</p>

				<span style={{ marginLeft: "20px" }}>{active ? "-" : "+"}</span>
			</div>
			<div
				ref={content}
				style={{
					display: "flex",
					justifyContent: "center",
					gap: "10px",
					padding: active ? "20px 0 20px 0" : undefined,
					height: active ? "100px" : "0px",
				}}
				className="accordion__content"
			>
				<Button
					onClick={() => window.open(props.content, "__blank")}
					variant="contained"
				>
					Foundation
				</Button>
				<Button
					onClick={() => window.open(props.prodoc, "__blank")}
					variant="contained"
				>
					Pro Doc
				</Button>
			</div>
		</div>
	);
}

export default Accordion;
